import "./Copyright.scss"

const Copyright = ({ copyrightMessaging }) => (
  <div className="Copyright" data-testid="Copyright">
    <div
      className="legal-copyright"
      style={{
        color: `white`,
      }}
    >
      {copyrightMessaging}
    </div>
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// Copyright.propTypes = {
//   copyrightMessaging: PropTypes.string.isRequired,
// }

export default Copyright
